module.exports = __webpack_public_path__ + "img/img02.b149fe94.jpeg";